// Main bundle file for Project Quadrant Tracker

// Workspace Number Card 点击跳转覆盖（捕获阶段拦截）
document.addEventListener('click', function(e) {
    // 方式1: 通过 block wrapper 的 number_card_name 属性匹配
    const wrapper = e.target.closest('[number_card_name]');
    if (wrapper) {
        const name = wrapper.getAttribute('number_card_name');
        if (name === '活跃项目数') {
            e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
            frappe.set_route('project_detail');
            return;
        }
        if (name === '待处理Q1任务') {
            e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
            frappe.set_route('personal_dashboard');
            return;
        }
        if (name === '本月新增知识') {
            e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
            window.open('/wiki/spaces', '_blank');
            return;
        }
    }

    // 方式2: 通过 widget 的 data-widget-name 属性匹配（备用）
    const widget = e.target.closest('.widget[data-widget-name]');
    if (widget) {
        const name = widget.getAttribute('data-widget-name');
        if (name === '活跃项目数') {
            e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
            frappe.set_route('project_detail');
            return;
        }
        if (name === '待处理Q1任务') {
            e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
            frappe.set_route('personal_dashboard');
            return;
        }
        if (name === '本月新增知识') {
            e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
            window.open('/wiki/spaces', '_blank');
            return;
        }
    }
}, true);

frappe.router.on('change', () => {
    const route = frappe.get_route();
    const app_pages = ['project_detail', 'division_dashboard', 'department_dashboard', 'personal_dashboard', 'person_detail'];
    const app_doctypes = ['Project', 'Task', 'Project Meeting'];
    
    const is_app_route = app_pages.includes(route[0]) || 
                         ((route[0] === 'Form' || route[0] === 'List') && app_doctypes.includes(route[1]));
    
    if (is_app_route) {
        $('body').addClass('quadrant-app-layout');
    } else {
        $('body').removeClass('quadrant-app-layout');
    }
});
